import daeulLogo from "@/assets/Daeul_logo_eng_v2_cropped.png";

const AdminBrandHeader = () => {
  return (
    <div className="flex flex-col items-center pt-12 pb-8 px-6">
      {/* Admin Icon Badge */}
      <div
        className="flex items-center justify-center w-14 h-14 rounded-xl mb-5 shadow-lg"
        style={{
          background: 'linear-gradient(135deg, #3B82F6 0%, #0EA5E9 100%)',
          boxShadow: '0 0 24px rgba(59,130,246,0.35)',
        }}
      >
        <i className="ri-shield-keyhole-line text-white text-2xl" />
      </div>

      {/* Brand Name */}
      <img src={daeulLogo} alt="Da:eul" className="h-12 w-auto object-contain" />

      {/* Admin Subtitle */}
      <p
        className="mt-2 text-sm text-slate-400 font-medium tracking-widest uppercase"
        style={{ fontFamily: '"Noto Sans KR", sans-serif', letterSpacing: '0.15em' }}
      >
        관리자 시스템
      </p>
    </div>
  );
};

export default AdminBrandHeader;
